import { RefObject, useEffect } from 'react';

/**
 *  Drag to scroll implementation found https://htmldom.dev/drag-to-scroll/
 *  No deps array -> if user resizes screen we want the hook to fire.
 */
export function useDragToScroll(ref: RefObject<HTMLDivElement | null>) {
  useEffect(() => {
    const grabbingArea = ref?.current;
    if (grabbingArea && grabbingArea.scrollWidth > grabbingArea.clientWidth) {
      let position = { top: 0, left: 0, x: 0, y: 0 };
      grabbingArea.style.cursor = 'grab';

      const mouseMoveHandler = (event: MouseEvent) => {
        // How far the mouse has been moved
        const diffX = event.clientX - position.x;
        const diffY = event.clientY - position.y;

        // Scroll the element
        grabbingArea.scrollTop = position.top - diffY;
        grabbingArea.scrollLeft = position.left - diffX;
      };

      const mouseUpHandler = () => {
        grabbingArea.style.cursor = 'grab';
        grabbingArea.style.removeProperty('user-select');

        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
      };

      const mouseDownHandler = (event: MouseEvent) => {
        grabbingArea.style.cursor = 'grabbing';
        grabbingArea.style.userSelect = 'none';

        position = {
          left: grabbingArea.scrollLeft,
          top: grabbingArea.scrollTop,
          // Get the current mouse position
          x: event.clientX,
          y: event.clientY,
        };

        document.addEventListener('mousemove', mouseMoveHandler);
        document.addEventListener('mouseup', mouseUpHandler);
      };
      // Attach the handler
      grabbingArea.addEventListener('mousedown', mouseDownHandler);

      return () => {
        grabbingArea.removeEventListener('mousedown', mouseDownHandler);
      };
    }
    if (grabbingArea && grabbingArea.scrollWidth <= grabbingArea.clientWidth) {
      grabbingArea.style.cursor = 'inherit';
    }
  });
}
